export default __webpack_public_path__ + "static/media/HeaderLogo.0441b8cf.svg";